<template>
  <div class="scroll-view" :id="name">
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .scroll-view{
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    .content{
      overflow: hidden;
    }
  }
</style>

<script>
  import BetterScroll from 'better-scroll'
  export default {
    props: {
      name: {
        type: String,
        default: 'workshop'
      }
    },
    data() {
      return {
        scrollView: null,
      }
    },
    mounted() {
      this.scrollView = new BetterScroll(`#${this.name}`, {
        click: true,
        probeType: 3,
        scrollbar: true,
        observeDOM: true,
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300
        }
      })
      this.scrollView.on('scroll', (pos) => {
        this.$emit('scroll', pos);
      })
    },
    methods: {
      refresh() {
        this.scrollView.refresh();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/scrollView.vue